module.exports = __webpack_public_path__ + "img/china.9e034d5.png";